import { createSelector } from '@ngrx/store';
import { AuthStore, AuthUserProfileStore } from '@arc/arc-shared-frontend';

export const selectUserEmail = createSelector(
  AuthUserProfileStore,
  (user) => user?.email,
);

/* istanbul ignore next */
export const selectUserPermissions = createSelector(
  AuthStore,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: any) => state?.permissions,
);
